import { ChatFormatMessage } from '@sp/util/stream-chat';
import { createContext, ReactNode, useContext } from 'react';

export type MessageTemplateProvider = (message: ChatFormatMessage) => ReactNode | undefined; // undefined means use default template

export const MessageTemplateContext = createContext<MessageTemplateProvider | undefined>(undefined);

export const useMessageTemplate = () => useContext(MessageTemplateContext);
